var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4673 0C27.633 0 31.8522 4.13004 31.9962 9.2614L32 9.53238V22.4666C32 27.6322 27.8698 31.8522 22.7383 31.9962L22.4673 32H9.53268C4.36699 32 0.147752 27.869 0.00379674 22.7376L0 22.4666V9.53238C0 4.36685 4.13017 0.147747 9.26169 0.00379663L9.53268 0H22.4673ZM22.4673 3.21862H9.53268C6.12354 3.21862 3.34471 5.92161 3.22289 9.30095L3.21872 9.53238V22.4666C3.21872 25.8757 5.9218 28.6544 9.30124 28.7762L9.53268 28.7804H22.4673C25.8774 28.7804 28.6553 26.0774 28.7771 22.6981L28.7813 22.4666V9.53238C28.7813 6.12335 26.0792 3.3446 22.6988 3.22279L22.4673 3.21862ZM15.5 7C20.1872 7 24 10.813 24 15.4995C24 20.187 20.1872 24 15.5 24C10.8128 24 7 20.187 7 15.4995C7 10.813 10.8128 7 15.5 7ZM15.5 10.3067C12.6312 10.3067 10.3065 12.6316 10.3065 15.5005C10.3065 18.3685 12.6312 20.6943 15.5 20.6943C18.3688 20.6943 20.6935 18.3685 20.6935 15.5005C20.6935 12.6316 18.3688 10.3067 15.5 10.3067ZM23.9995 6C25.1042 6 26 6.89581 26 7.9995C26 9.10419 25.1042 10 23.9995 10C22.8948 10 22 9.10419 22 7.9995C22 6.89581 22.8948 6 23.9995 6Z",
    fill: "#7C7C7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/IG.dbe76a049331da9d59255d63ba022658.svg";
export { ForwardRef as ReactComponent };